<template>
  <div class="modal_clients">
    <div class="modal_clients__header">
      <h4 class="title">
        {{ primary_data.client.name ? primary_data.client.name : translate("client.new_client") }}
      </h4>
    </div>
    <div class="modal_clients__body">

      <div
          v-if="loading"
          style="border:none; background-color:  transparent;"
      >
        <span> <scale-loader /> </span>
      </div>

      <div class="client" v-else>
        <div class="tab">
          <span
              class="tab_title"
              :class="{ active : block==='MainInfo'}"
              @click="selected_block('MainInfo')"
          >
            {{this.translate('client.main_info.title')}}
          </span>
          <span
              v-if="primary_data.client?.id"
              class="tab_title"
              :class="{ active : block==='DeviceGroups'}"
              @click="selected_block('DeviceGroups')"
          >
            {{this.translate('client.groups.title')}}
          </span>
          <span
              v-if="primary_data.client?.id"
              class="tab_title"
              :class="{ active : block==='Users'}"
              @click="selected_block('Users')"
          >
            {{this.translate('client.users.title')}}
          </span>
<!--          <span class="tab_title" :class="{ active : block==='Contracts'}" @click="selected_block('Contracts')">{{this.translate('client.contracts.title')}}</span>-->
          <span
              v-if="primary_data.client?.id"
              class="tab_title"
              :class="{ active : block==='Comments'}"
              @click="selected_block('Comments')"
          >
            {{this.translate('client.comments.title')}}
          </span>
        </div>
        <div class="block">
          <MainInfo
              v-if="block==='MainInfo'"
              :client="info"
              @update_client="update_client"
          />
          <DeviceGroups
              v-if="block==='DeviceGroups'"
              @cancel="cancel"
              :groups="groups"
          />
          <Users
              v-if="block==='Users'"
              @cancel="cancel"
              :users="users"
          />
<!--          <Contracts v-if="block==='Contracts'" :contracts="contracts"/>-->
          <Comments
              v-if="block==='Comments'"
              :params="comments_params"
          />
        </div>
      </div>


    </div>
    <div class="modal_clients__footer">
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
        >
          {{ translate('close_modal') }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo";
import DeviceGroups from "./Tabs/DeviceGroups";
import Users from "./Tabs/Users";
// import Contracts from "./Tabs/Contracts";
import Comments from "@/views/Dashboard/common/General/Summary/Comments.vue";

export default {
  name: 'ClientModal',
  props: ['client_id'],
  components: {
    MainInfo,
    DeviceGroups,
    Users,
    // Contracts,
    Comments
  },
  data () {
    return {
      block: 'MainInfo',
      primary_data: {
        client:{
          name: ''
        }
      },
      client_info: {},
      loading: true
    }
  },
  computed:{
    info(){ return this.primary_data.client },
    contracts(){ return this.primary_data.contracts },
    users(){ return this.primary_data.users },
    groups(){ return this.primary_data.device_groups },
    comments_params(){ return {client_id: this.primary_data.client?.id }},
    last_url(){ return this.$route.params.client_id }
  },
  created() {
    this.init()
  },

  destroyed(){
    this.close_modal()
  },

  methods: {
    cancel () {
      this.$emit('close')
    },
    selected_block(block){
      this.block = block
    },
    update_client(data){
      this.primary_data = data
      this.$emit('update')
    },
    init(){
      if (this.client_id){
        this.$http.v1.getClientInfo(this.client_id, (response) => {
          this.primary_data = response.data
          this.loading = false
        })

        if (!this.$route.params.client_id) {
          this.old_url = this.$route.fullPath
          history.pushState(null, null, window.location.href + '/' + this.client_id)
        }
      }else{
        this.primary_data = {
          client: {},
          contracts: {},
          users: {},
          device_groups: {}
        }
        this.loading = false
      }
    },
    close_modal () {
      if (this.last_url) {
        let full_path = this.$route.fullPath.split('/')

        let new_window = ''
        if (this.last_url === full_path[full_path.length - 1]){
          new_window = this.$route.fullPath.replace('/'+ this.last_url, '')
        }else{
          new_window = this.$route.fullPath.replace('/'+ full_path[full_path.length - 1], '')
        }
        this.$router.push(new_window)
      }else{
        this.$router.push(this.old_url)
      }
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_clients{
    height: 100%;
    padding: 10px;
    &__header{
      height: 5%;
      .title{
        margin: 0;
        text-align: center;
      }
    }
    &__body{
      width: 100%;
      height: 90%;
      .client{
        width: 100%;
        height: 100%;
        .tab{
          width: 100%;
          height: 5%;
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: row;
          &_title{
            width: 100%;
            padding: 5px 0;
            cursor: pointer;
            font-weight: 600;
            text-align: center;
            background-color: #efe9e9;
            border: 1px solid #efe9e9;
            &.active{
              background-color: #FFFFFF;
              border-bottom: 1px solid white;
            }
          }
        }
        .block{
          height: 95%;
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
        }
      }

    }
    &__footer{
      height: 5%;
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }


</style>
